<template>
 <div class="cultureorder pb100">
   <banner/>
  <crumbs/>
  <div class="container">
    <div class="bgfff p30 mt20">
      <h2 class="title"><span>我要点单</span></h2>
      <el-form ref="formdata" :model="formdata" :rules="formrules" label-width="80px">
        <ul class="ul1">
          <li v-for="(item, index) in typeList" :key="index">
            <label>{{ item.name }}</label>
            <el-cascader
              :ref="'cascader'+index"
              v-model="typeList[index].cascader"
              :options="item.children"
              :props="{ expandTrigger: 'hover', label: 'name', value: 'id' }"
              :append-to-body="false"
              @change="handleChange"></el-cascader>
          </li>
        </ul>
        <el-form-item label="内容" prop="content" class="clearfixfloat">
          <i class="icon icon5"></i>
          <el-input v-model="formdata.content" placeholder="内容"></el-input>
        </el-form-item>
        <div class="describe">以下信息便于问题核实，不对外公开，请放心填写：</div>
        <div class="clearfix">
          <el-form-item label="姓名" prop="orderName">
            <el-input v-model="formdata.orderName" placeholder="姓名"></el-input>
          </el-form-item>
          <el-form-item label="联系方式" prop="orderTelphoneNum">
            <el-input v-model="formdata.orderTelphoneNum" placeholder="联系方式"></el-input>
          </el-form-item>
          <el-form-item label="验证码" class="codeimg" prop="code">
            <el-input v-model="formdata.code" placeholder="验证码"></el-input>
            <img :src="picCode" alt="" @click="getPicCode">
          </el-form-item>
        </div>
        <el-form-item class="clearfixfloat">
          <el-button type="primary" @click="onSubmit">提交</el-button>
        </el-form-item>
      </el-form>
      <h2 class="title mt20"><span>答复中心</span></h2>
      <ul class="ul2">
        <li v-for="(item, index) in List" :key="index">
          <div class="mb10 topbox">
            <h4 class="name">{{ item.orderName }}</h4>
            <div v-if="item.typeValues && item.typeValues.length !== 0">
              <span v-for="(items, index) in item.typeValues" :key="index">{{ items.value }}</span>
            </div>
          </div>
          <dl>
            <dt></dt>
            <dd>
              <div>{{ item.content }}</div>
              <span class="date">留言时间：{{ getTime(item.insertTime) }}</span>
            </dd>
          </dl>
          <dl v-if="item.answer !== undefined && item.answer !== ''">
            <dt></dt>
            <dd><div class="gray">{{ item.answer }}</div></dd>
          </dl>
        </li>
      </ul>
      <h2 class="loadmore pt30" :class="{ cursorp: moreorderDesc }" v-if="loadMore" @click="loadMoreorder">{{ moreorderDesc === true ? '查看更多点单' : '已显示全部点单' }}</h2>
      <h2 class="nodata pt30" v-if="noData">暂无数据</h2>
    </div>
  </div>
 </div>
</template>

<script>
import crumbs from '@/components/crumbs/index'
import banner from '@/components/banner/index'
import { getTypeList } from '@/api/typescreen/index'
// import { scrollAnimation } from '@/utils/index'
import { getCultureOrderList, addCultureOrder } from '@/api/cultureorder/index'
import { timeFormat } from '@/utils/validate'
export default {
  name: 'culturalorder',
  meta: {
    showHeader: true
  },
  components: {
    crumbs,
    banner
  },
  data () {
    return {
      formdata: {
        orderName: '',
        orderTelphoneNum: '',
        code: '',
        content: '',
        types: '',
        departmentCode: this.$cookie.get('museumCode'),
        menuId: this.$route.query.columnId
      },
      formtypes: [],
      formrules: {
        orderName: [{required: true, message: '请输入姓名', trigger: 'blur'}],
        orderTelphoneNum: [{required: true, message: '请输入联系方式', trigger: 'blur'}],
        code: [{required: true, message: '请输入验证码', trigger: 'blur'}],
        content: [{required: true, message: '请输入内容', trigger: 'blur'}]
      },
      Param: {
        pageNum: 1,
        limit: 10,
        types: ''
      },
      noData: false,
      currentPage: 1,
      List: [],
      listTotal: 0,
      typeParam: {
        'dictParentCode': '',
        'menuId': this.$route.query.columnId
      },
      picCode: '',
      typeList: [],
      loadMore: false,
      moreorderDesc: true
    }
  },
  mounted () {
    this.getPicCode()
    this.getTypeList()
    this.getList()
  },
  methods: {
    getTime (val) {
      return timeFormat(val, 'yymmdd')
    },
    getPicCode () {
      this.picCode = process.env.BASE_API + '/api/auth/jwt/getCode?' + new Date().getTime() + '&phone=' + this.$cookie.get('wlymobilephone')
    },
    getList () {
      getCultureOrderList(this.$route.query.columnId, this.Param).then(res => {
        if (res.data.status === 0) {
          if (res.data.totalSize > 0) {
            this.noData = false
            this.listTotal = res.data.totalSize
            if (res.data.data.length === this.Param.limit) this.loadMore = true
            if (this.Param.pageNum === 1) {
              this.List = res.data.data
            } else {
              this.List = this.List.concat(res.data.data)
              if (res.data.data.length < this.Param.limit) this.moreorderDesc = false
            }
          } else {
            this.noData = true
          }
        }
      })
    },
    /* 查看更多 */
    loadMoreorder () {
      let orderPageTotal = Math.ceil(this.listTotal / this.Param.limit)
      if (this.Param.pageNum < orderPageTotal) {
        this.Param.pageNum++
        this.getList()
      } else {
        this.moreorderDesc = false
      }
    },
    getTypeList () {
      getTypeList(this.typeParam).then((res) => {
        if (res.data.status === 200) {
          this.typeList = this.getTreeData(res.data.data.customType)
          this.typeList.forEach((item) => {
            item.cascader = []
          })
        }
      })
    },
    // 递归方法
    getTreeData (data) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].children.length < 1) {
          // children若为空数组，则将children设为undefined
          data[i].children = undefined
        } else {
          // children若不为空数组，则继续 递归调用 本方法
          this.getTreeData(data[i].children)
        }
      }
      return data
    },
    handleChange (value) {
      console.log(value)
      let newvalue = value
      let parentval = this.getParentIdList(newvalue[0], this.typeList)
      let currentArr = [parentval[0].id].concat(value)
      if (this.formtypes.length === 0) {
        this.formtypes.push({'currentIndex': parentval[0].currentIndex, data: currentArr})
      } else {
        let currentId = ''
        this.formtypes.forEach((item, index) => {
          if (item.currentIndex === parentval[0].currentIndex) {
            currentId = index
            return false
          }
        })
        if (currentId === '') {
          this.formtypes.push({'currentIndex': parentval[0].currentIndex, data: currentArr})
        } else {
          this.formtypes.forEach((item, index) => { if (item.currentIndex === currentId) item.data = currentArr })
        }
      }
    },
    getParentIdList (childrenId, arr, path) {
      if (path === undefined) {
        path = []
      }
      for (let i = 0; i < arr.length; i++) {
        let tmpPath = path.concat()
        tmpPath.push({'id': arr[i].id, 'currentIndex': i})
        if (parseInt(childrenId) === parseInt(arr[i].id)) {
          return tmpPath
        }
        if (arr[i].children) {
          let findResult = this.getParentIdList(childrenId, arr[i].children, tmpPath)
          if (findResult) {
            return findResult
          }
        }
      }
    },
    // 提交点单
    onSubmit () {
      this.$refs.formdata.validate((valid) => {
        if (valid) {
          // types
          if (this.formtypes.length === 0) {
            let messagedata = []
            this.typeList.forEach((item) => {
              messagedata.push(item.name)
            })
            this.$message.error('请选择' + messagedata.join('、') + '类型')
          } else {
            if (this.formtypes.length !== this.typeList.length) {
              for (let i = 0; i < this.typeList.length; i++) {
                for (let j = 0; j < this.formtypes.length; j++) {
                  if (i !== this.formtypes[j].currentIndex) {
                    this.$message.error('请选择' + this.typeList[i].name + '类型')
                    return false
                  }
                }
              }
              return false
            }
            this.formdata.types = ''
            let newtypesArr = []
            this.formtypes.forEach((item) => {
              newtypesArr.push(item.data.join(':'))
            })
            this.formdata.types = newtypesArr.join(',')
          }
          addCultureOrder(this.formdata).then(res => {
            if (res.data.status === 200) {
              if (res.data.message === '验证码错误"') {
                this.getPicCode()
                return false
              }
              this.$message.success(res.data.message)
              this.typeList.forEach((item) => {
                item.cascader = []
              })
              this.$refs.formdata.resetFields()
            } else {
              this.$message.error(res.data.message)
            }
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.cultureorder{
  .describe{
    margin: 10px 0 20px 80px;
    color: #f0736d;
  }
  h2.title{
    border-bottom: 1px solid #ececec;
    margin: 0 0 22px 0;
    span{
      display: inline-block;
      width: 118px;
      height: 41px;
      line-height: 41px;
      border: 1px solid #ececec;
      border-bottom: 0 none;
      background: #f9f9f9;
      font-size: 16px;
      color: #333;
      text-align: center;
      letter-spacing: 3px;
      -moz-border-top-left-radius: 8px;
      -webkit-border-top-left-radius: 8px;
      border-top-left-radius: 8px;
      -moz-border-top-right-radius: 8px;
      -webkit-border-top-right-radius: 8px;
      border-top-right-radius: 8px;
      position: relative;
    }
  }
  ul.ul1{
    li{
      margin-bottom: 22px;
      label{
        display: inline-block;
        width: 78px;
        text-align: right;
        padding: 0 10px 0 0;
      }
    }
  }
  ul.ul2{
    li{
      margin: 0 0 20px 0;
      padding: 5px 0 10px 0;
      border-bottom: 1px solid #ececec;
      .topbox{
        display: flex;
        justify-content: space-between;
        .name{
          line-height: 28px;
          font-size: 16px;
        }
        div{
          span{
            display: inline-block;
            padding: 0 10px;
            font-style: normal;
            height: 28px;
            line-height: 28px;
            font-size: 14px;
            text-align: center;
            border: 1px solid #e7f5f0;
            background: #e7f5f0;
            color: #54b991;
            border-radius: 15px;
            margin: 0 0 0 10px;
          }
        }
      }
      dl{
        position: relative;
        dt{
          display: block;
          width: 44px;
          line-height: 22px;
          color: #333;
          white-space: nowrap;
          position: absolute;
          left: 0;
          top: 0;
        }
        dd{
          line-height: 22px;
          padding-bottom: 8px;
          font-size: 14px;
          color: #666;
          position: relative;
          padding-left: 44px;
          word-break: break-all;
          min-height: 32px;
          .date{
            display: inline-block;
            line-height: 30px;
            color: #999;
            font-size: 12px;
          }
          .gray{
            background: #f2f2f2;
            padding: 10px 15px;
            border-radius: 4px;
          }
        }
      }
    }
  }
  .el-form{
    .el-form-item{
      width: 48%;
      float: left;
      position: relative;
      .el-input__inner{
        border-radius: 0;
      }
      &:nth-child(odd){
        margin-right: 4%;
      }
      &.clearfixfloat{
        width: 100%;
        float: none;
      }
      &.codeimg img {
        position: absolute;
        height: 38px;
        right: 1px;
        top: 1px;
        display: block;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/culturalorder/list.vue